import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import { PagedResponse } from '@types_main/paged-response';
import { PagedParams } from '@types_main/paged.params';
import { PeopleImportRequest, PersonImportRow, PersonRequest } from './requests/person.request';
import {
    PeopleImportPreviewRow, PeopleImportResult, PersonOptionResponse, PersonResponse,
} from './responses/person.response';

export class PersonService extends BaseService {
    protected get resourceName(): string {
        return 'crm/people';
    }

    public async getAll(
        filter?: string,
        params?: PagedParams
    ): Promise<AxiosResponse<PagedResponse<PersonResponse>>> {
        return await this.get<PagedResponse<PersonResponse>>('paginated' + (filter ?? ''), params);
    }

    public async getById(id: string): Promise<AxiosResponse<{ data: PersonResponse }>> {
        return await this.get(id);
    }

    public async create(body: PersonRequest): Promise<AxiosResponse<{ data: PersonResponse }>> {
        return await this.post(body);
    }

    public async update(id: string, body: PersonRequest): Promise<AxiosResponse<{ data: PersonResponse }>> {
        return await this.put(id, body);
    }

    public async deleteById(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(id);
    }

    /// Lista para seletor, em ordem alfabética; separada da paginada, que ordena por último contato.
    public async options(): Promise<AxiosResponse<{ data: PersonOptionResponse[] }>> {
        return await this.get("options");
    }

    /// O que vai acontecer com cada linha, sem gravar nada.
    public async previewImport(
        rows: PersonImportRow[]
    ): Promise<AxiosResponse<{ data: PeopleImportPreviewRow[] }>> {
        return await this.post({ rows }, 'import/preview');
    }

    public async import(
        body: PeopleImportRequest
    ): Promise<AxiosResponse<{ data: PeopleImportResult }>> {
        return await this.post(body, 'import');
    }
}
